import { withIconWrapper } from 'hocs/withIconWrapper';

import { ReactComponent } from './GlassesIcon.c.svg';

export const GlassesIcon = withIconWrapper(ReactComponent);
